/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.1",
    versionName: "0.2.0-nightly.2026.5.1",
    versionChannel: "nightly",
    buildDate: "2026-05-01T00:23:42.067Z",
    commitHash: "0708ade3c07ff13b5fc68d742b9471c6c40ffee2",
};
